/**
 * Funções puras de filtro para grids (GridPadrao, PainelConsolidadoDocumentos).
 * Extraídas do componente para não serem recriadas a cada render.
 */

/** Normaliza data para timestamp (meia-noite local) - evita problemas de timezone */
export function parseDateToTimestamp(dateStr) {
  if (!dateStr) return null;
  const str = String(dateStr).trim();
  let year, month, day;

  const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    year = parseInt(isoMatch[1], 10);
    month = parseInt(isoMatch[2], 10) - 1;
    day = parseInt(isoMatch[3], 10);
  } else {
    const brMatch = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (brMatch) {
      day = parseInt(brMatch[1], 10);
      month = parseInt(brMatch[2], 10) - 1;
      year = parseInt(brMatch[3], 10);
    } else {
      const d = new Date(str);
      if (isNaN(d.getTime())) return null;
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    }
  }

  const d = new Date(year, month, day);
  return isNaN(d.getTime()) ? null : d.getTime();
}

/** Aplica o filtro de datas com operadores =, >, <, >= ou <= */
export function applyDateFilter(rowDate, filter) {
  if (!filter?.value) return true;

  const op = filter.operator || "=";
  const rowTs = parseDateToTimestamp(rowDate);
  const filterTs = parseDateToTimestamp(filter.value);

  if (rowTs == null) return false;
  if (filterTs == null) return true;

  if (op === ">") return rowTs > filterTs;
  if (op === "<") return rowTs < filterTs;
  if (op === ">=") return rowTs >= filterTs;
  if (op === "<=") return rowTs <= filterTs;
  return rowTs === filterTs;
}

/** Retorna o valor filtrável de acordo com o tipo da coluna */
export function getFilterableValue(row, columnAccessor, columnConfig) {
  if (columnConfig?.getFilterValue) {
    return String(columnConfig.getFilterValue(row) || "").toLowerCase();
  }
  if (columnAccessor === "situacao") {
    const s = row.situacao;
    return String(s || "").toLowerCase();
  }
  return String(row[columnAccessor] || "").toLowerCase();
}

/** Aplica filtro numérico (ex.: dias para vencimento) */
export function applyNumericFilter(rowValue, filterValue) {
  if (!filterValue) return true;
  return rowValue === filterValue;
}
